import { ENV } from '$env';
import { BairroProvider } from '$providers/bairro';
import { DenunciaProvider } from '$providers/denuncia';
import { ImageProvider } from '$providers/image';
import { MapProvider } from '$providers/map';
import { SettingsProvider } from '$providers/settings';
import { TipoQueixaProvider } from '$providers/tipo-queixa';
import { ViewProvider } from '$providers/view';
import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavController } from 'ionic-angular';
import { SelecionarBairroPage } from '../../selecionar-bairro/selecionar-bairro';
import { TermoAceiteViewPage } from '../../termo-aceite-view/termo-aceite-view';

@Component({
  selector: 'page-denuncia-form',
  templateUrl: 'denuncia-form.html',
})
export class DenunciaFormPage {

  web = false;
  maxImages = 3;

  bairro: any;
  bairroNome: any;

  validations = { descricao: { min: 20, max: 300 } };

  place: any; // Utilizado para trabalhar com o mapa

  denuncia: {
    descricao: string,
    informacaoEmpresa: string,
    tipoQueixaId: number,
    endereco: {
      rua: string,
      numero: string,
      cep: string,
      bairro: number,
      complemento: string,
      referencia: string,
      latitude: number,
      longitude: number
    },
    imagens: Array<any>
  };

  captcha: any;

  tiposQueixa: Array<any> = [];

  constructor(private navCtrl: NavController, private sanitizer: DomSanitizer,
    private bairroProvider: BairroProvider, private _view: ViewProvider,
    private _denuncia: DenunciaProvider, private imageProvider: ImageProvider,
    private mapProvider: MapProvider, private settings: SettingsProvider, private movitoQueixaProvider: TipoQueixaProvider) {
    this.denuncia = {
      descricao: '',
      informacaoEmpresa: '',
      tipoQueixaId: 0,
      endereco: {
        rua: '',
        numero: '',
        cep: '',
        bairro: null,
        complemento: '',
        referencia: '',
        latitude: 0,
        longitude: 0
      },
      imagens: []
    };

    this.web = ENV.web;
  }

  ionViewDidLoad() {
    this.movitoQueixaProvider.get().subscribe(
      (dados) => this.tiposQueixa = dados,
      (err) => console.error(err)
    );
  }

  public loadImage() {
    if (this.denuncia.imagens.length >= this.maxImages) {
      return;
    }

    let successCallback = (imageData) => {
      for (let i = this.denuncia.imagens.length - 1; i >= 0; i--) {
        if (this.denuncia.imagens[i].dados === imageData) {
          this._view.showMessage("Esta imagem já foi selecionada.");
          return;
        }
      }

      this.denuncia.imagens.splice(0, 0, { dados: imageData });
    };

    let errorCallback = (error) => {
      console.error('Não foi possível carregar a imagem selecionada. ' + error);

      if (error == "has no access to camera" || error == "has no access to assets") {
        return;
      }

      if (error != 'No Image Selected')
        this._view.showError('Não foi possível carregar a imagem selecionada.<br>Erro:' + error);
    };

    this._view.showActionSheet([
      { icon: 'camera', text: 'Câmera', handler: () => { this.imageProvider.getImageFromCamera().subscribe(successCallback, errorCallback); } },
      { icon: 'images', text: 'Galeria', handler: () => { this.imageProvider.getImageFromLibrary().subscribe(successCallback, errorCallback); } },
      { icon: 'close', text: 'Cancelar', role: 'destructive' }
    ]);
  }

  public getImage(imageData): any {
    let imageBase64 = this.imageProvider.uriToBase64(imageData);
    return this.sanitizer.bypassSecurityTrustUrl(imageBase64);
  }

  public deleteImage(image) {
    this._view.showConfirm('Deseja remover a imagem selecionada?', () => {
      for (let i = this.denuncia.imagens.length - 1; i >= 0; i--) {
        if (this.denuncia.imagens[i].dados === image.dados) {
          this.denuncia.imagens.splice(i, 1);
        }
      }
    });
  }

  public validate(): boolean {
    let valido = true;
    let msg = "";


    // if (!this.denuncia.tipoQueixaId) {
    //   valido = false;
    //   msg += '- <b>Categoria</b> não informada.<br />';
    // }

    if (!this.denuncia.informacaoEmpresa) {
      valido = false;
      msg += '- <b>Empresa denunciada</b> não informada.<br />';
    }

    if (!this.denuncia.endereco.rua) {
      valido = false;
      msg += '- <b>Endereço</b> não informado.<br />';
    } else if (this.denuncia.endereco.rua.length > 100) {
      valido = false;
      msg += '- <b>Endereço</b> não deve ultrapassar 100 caracteres.<br />';
    }

    if (!this.denuncia.endereco.numero) {
      valido = false;
      msg += '- <b>Número</b> não informado.<br />';
    } else if (this.denuncia.endereco.numero.length > 10) {
      valido = false;
      msg += '- <b>Número</b> não deve ultrapassar 10 caracteres.<br />';
    }

    if (!this.denuncia.endereco.bairro) {
      valido = false;
      msg += '- <b>Bairro</b> não informado.<br />';
    }

    if (!this.denuncia.endereco.referencia) {
      valido = false;
      msg += '- <b>Referência</b> não informada.<br />';
    }

    if (!this.denuncia.descricao) {
      valido = false;
      msg += '- <b>Descrição</b> não informada.<br />';
    } else if (this.denuncia.descricao.trim().length < this.validations.descricao.min) {
      valido = false;
      msg += `- <b>Descrição</b> deve conter no mínimo ${this.validations.descricao.min} caracteres.<br />`;
    } else if (this.denuncia.descricao.trim().length > this.validations.descricao.max) {
      valido = false;
      msg += `- <b>Descrição</b> não deve ultrapassar ${this.validations.descricao.max} caracteres.<br />`;
    }

    if (!valido) {
      this._view.showWarn(msg);
    }

    return valido;
  }

  public showMap() {
    this.mapProvider.getPlace(this.place).subscribe(
      (p) => {
        if (p) {
          this.place = p;
          let address = this.mapProvider.parsePlace(this.place);

          this.denuncia.endereco.rua = (address.route) ? address.route : '';
          this.denuncia.endereco.numero = (address.street_number) ? address.street_number : 'S/N';
          this.denuncia.endereco.cep = address.postal_code;
          this.denuncia.endereco.referencia = (address.name) ? address.name : '';
          this.denuncia.endereco.latitude = address.lat;
          this.denuncia.endereco.longitude = address.lng;

          this.bairroProvider.getByName(address.sublocality).subscribe((b) => this.setBairro(b));
        }
      });
  }

  public selectBairro() {
    this._view.showModalPage(SelecionarBairroPage, { bairro: this.bairro }, (b) => this.setBairro(b));
  }

  private setBairro(bairro) {
    if (bairro) {
      this.bairro = bairro;
      this.bairroNome = bairro.nome;
      this.denuncia.endereco.bairro = bairro.id;
    } else {
      this.bairro = null;
      this.bairroNome = null;
      this.denuncia.endereco.bairro = undefined;
    }
  }

  public submit() {
    if (!this.validate()) {
      return;
    }

    let termoAceite = this.settings.getServerSettings().termoAceite;
    if (!termoAceite || !termoAceite.length) {
      this._view.showConfirmWithButtons("Confirma o envio das informações?",
        [{
          text: 'Não',
          role: 'cancel'
        },
        {
          text: 'Sim',
          handler: () => { this.submitAfterTerms(); }
        }]);
      return;
    }

    this._view.showConfirmWithButtons("Você está de acordo com os termos de uso deste aplicativo?",
      [{
        text: 'Não',
        role: 'cancel'
      },
      {
        text: 'Ver Termos',
        handler: () => { this.viewTerms(); }
      },
      {
        text: 'Sim',
        handler: () => { this.submitAfterTerms(); }
      }]);

  }

  viewTerms() {
    this._view.showModalPage(TermoAceiteViewPage, {}, (data) => {
      if (data && data.concordo) {
        this.submitAfterTerms();
      } else {
        this._view.showMessage("Os termos de uso não foram aceitos.");
      }
    });
  }

  submitAfterTerms() {
    this._denuncia.addItem(this.denuncia, this.captcha).subscribe(
      (data) => {
        let retorno = data.mensagem;

        this._view.showMessage(retorno);

        this.navCtrl.pop();
      },
      (error) => console.error('Erro ao realizar requisição. ' + error)
    );
  }

  setFocus(componente) {
    componente.setFocus();
  }
}



// WEBPACK FOOTER //
// ./src/pages/denuncia/denuncia-form/denuncia-form.ts